import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this._onInspect = (e) => {
            const { align, case: kase } = e.detail || {}

            // align buttons
            this._activateByValue(".format-btn", "align", align || "center")

            // case buttons
            this._activateByValue(".case-toggle-btn", "case", kase || "uppercase")
        }
        document.addEventListener("ie:inspect", this._onInspect)
    }

    disconnect() {
        document.removeEventListener("ie:inspect", this._onInspect)
    }

    _activateByValue(selector, dataAttr, val) {
        this.element.querySelectorAll(selector).forEach(btn => {
            const on = btn.dataset[dataAttr] === val
            btn.classList.toggle("active", on)
            btn.setAttribute("aria-pressed", String(on))
        })
    }
    align(e) {
        e.preventDefault()
        const btn = e.currentTarget
        this._toggleGroup(btn, ".format-btn")
        const align = btn.dataset.align || "left"

        // fire globally so the editor (in another column) can hear it
        document.dispatchEvent(new CustomEvent("ie:align", { detail: { align } }))
    }

    case(e) {
        e.preventDefault()
        const btn = e.currentTarget
        this._toggleGroup(btn, ".case-toggle-btn")
        const kase = btn.dataset.case || "uppercase"

        document.dispatchEvent(new CustomEvent("ie:case", { detail: { case: kase } }))
    }

    _toggleGroup(activeBtn, selector) {
        const group = activeBtn.closest(".control-row").querySelectorAll(selector)
        group.forEach(b => {
            const isActive = b === activeBtn
            b.classList.toggle("active", isActive)
            b.setAttribute("aria-pressed", String(isActive))
        })
    }
}